import client from '../request'

const getAll = `activities`

const get = (id) => {
  return `/activities/${id}`
}

const create = (data) => {
  return client.post('/activities', data)
}

const update = (id, data) => {
  return client.put(`/activities/${id}`, data)
}

const remove = (id, data) => {
  return client.delete(`/activities/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const ActivityService = {
  getAll,
  get,
  create,
  update,
  toRow,
  toPaginate,
  remove
}

export default ActivityService
